module.exports = __webpack_public_path__ + "img/29_48.66f28966.png";